import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

class DefinitionDiffModal extends Component {
  render() {
    const {open, objectName, sourceDef, targetDef, onClose} = this.props;

    return (
      <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="lg" data-testid="sc-definition-modal">
        <DialogTitle>SQL Definition Diff — {objectName}</DialogTitle>
        <DialogContent>
          <div className="sc-definition-panes">
            <div className="sc-definition-side">
              <div className="sc-definition-side-label">Source</div>
              <pre className="sc-definition-pre" data-testid="sc-definition-source">
                {sourceDef || '(not available)'}
              </pre>
            </div>
            <div className="sc-definition-side">
              <div className="sc-definition-side-label">Target</div>
              <pre className="sc-definition-pre" data-testid="sc-definition-target">
                {targetDef || '(not available)'}
              </pre>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} data-testid="sc-definition-close">Close</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default DefinitionDiffModal;
